/* GSLION — theme.js (global)
   Header drawer, cart drawer, cart fetch ops, ESC handling, announcement scroll.
   No deps. Defer-loaded. */
(() => {
  'use strict';

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Drawer pattern ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = el.querySelector('[data-drawer-close], [autofocus], input, a, button');
    setTimeout(() => focusable?.focus({ preventScroll: true }), 240);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.style.overflow = '';
  }

  /* ---------- Wire all drawers ---------- */
  $$('[data-drawer]').forEach(drawer => {
    const id = drawer.dataset.drawer;
    $$('[data-drawer-open="' + id + '"]').forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      openDrawer(drawer);
    }));
    $$('[data-drawer-close]', drawer).forEach(b => b.addEventListener('click', () => closeDrawer(drawer)));
    $('.drawer__overlay', drawer)?.addEventListener('click', () => closeDrawer(drawer));
  });

  /* ESC closes any open drawer */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Announcement bar hide on scroll ---------- */
  const announce = $('[data-announce]');
  if (announce) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          announce.style.transform = window.scrollY > 80 ? 'translateY(-100%)' : '';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- Cart ---------- */
  const cartDrawer = $('[data-drawer="cart"]');

  async function refreshCart() {
    try {
      const r = await fetch('/?sections=cart-drawer,header-cart-link', {
        headers: { 'Accept': 'application/json' }
      });
      if (!r.ok) return;
      const data = await r.json();
      if (data['cart-drawer']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        const newBody = tmp.querySelector('[data-cart-body]');
        const newCount = tmp.querySelector('[data-cart-count]');
        if (cartDrawer) {
          const body = $('[data-cart-body]', cartDrawer);
          if (body && newBody) body.innerHTML = newBody.innerHTML;
          const countEl = $('[data-cart-count]', cartDrawer);
          if (countEl && newCount) countEl.textContent = newCount.textContent;
        }
      }
      if (data['header-cart-link']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['header-cart-link'];
        const newLink = tmp.querySelector('[data-cart-link]');
        const existing = $('[data-cart-link]');
        if (existing && newLink) existing.replaceWith(newLink);
        wireCartOpeners();
      }
    } catch (_) { /* silent */ }
  }

  async function changeLine(id, quantity) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity })
      });
      if (!r.ok) throw new Error('change_failed');
      await refreshCart();
    } catch (_) { /* silent */ }
  }

  function wireCartOpeners() {
    $$('[data-cart-open]').forEach(el => {
      if (el.dataset.wired) return;
      el.dataset.wired = '1';
      el.addEventListener('click', e => {
        e.preventDefault();
        openDrawer(cartDrawer);
      });
    });
  }
  wireCartOpeners();

  /* Delegated handlers inside cart drawer */
  if (cartDrawer) {
    cartDrawer.addEventListener('click', e => {
      const inc = e.target.closest('[data-line-change]');
      const rm  = e.target.closest('[data-line-remove]');
      if (!inc && !rm) return;
      e.preventDefault();
      const row = e.target.closest('[data-line]');
      if (!row) return;
      const id = row.dataset.line;
      const valEl = row.querySelector('[data-line-qty]');
      const current = parseInt(valEl?.textContent || '1', 10);
      if (rm) {
        changeLine(id, 0);
      } else {
        const delta = parseInt(inc.dataset.lineChange, 10);
        changeLine(id, Math.max(0, current + delta));
      }
    });
  }

  /* ---------- Collection: Load more (Section Rendering API) ---------- */
  const loadMoreBtn = $('[data-load-more]');
  const grid = $('[data-cp-grid]');
  if (loadMoreBtn && grid) {
    const countEl = $('[data-load-more-count]');
    let nextUrl = loadMoreBtn.getAttribute('href');

    loadMoreBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!nextUrl || loadMoreBtn.classList.contains('is-loading')) return;
      const label = $('[data-load-more-label]', loadMoreBtn);
      const original = label.textContent;
      loadMoreBtn.classList.add('is-loading');
      label.textContent = 'Loading…';

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', 'collection-grid-page');
        const r = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!r.ok) throw new Error('load_failed');
        const html = await r.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Append new cards
        const newGrid = tmp.querySelector('[data-cp-grid]');
        if (newGrid) {
          newGrid.querySelectorAll(':scope > *').forEach(card => grid.appendChild(card));
        }

        // Find next pagination link in new response
        const newMoreBtn = tmp.querySelector('[data-load-more]');
        if (newMoreBtn) {
          nextUrl = newMoreBtn.getAttribute('href');
        } else {
          nextUrl = null;
          loadMoreBtn.style.display = 'none';
        }

        // Update count
        if (countEl) {
          countEl.textContent = grid.children.length;
        }

        label.textContent = original;
        loadMoreBtn.classList.remove('is-loading');

        // Update URL without reload
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.set('page', new URL(url).searchParams.get('page'));
        history.replaceState({}, '', cleanUrl);

      } catch (_) {
        label.textContent = 'Try again';
        loadMoreBtn.classList.remove('is-loading');
      }
    });
  }



  /* ---------- Search overlay ---------- */
  const so = $('[data-search-overlay]');
  if (so) {
    const input        = $('[data-search-input]', so);
    const clearBtn     = $('[data-search-clear]', so);
    const defaultView  = $('[data-search-default]', so);
    const resultsView  = $('[data-search-results]', so);
    const loadingView  = $('[data-search-loading]', so);
    const emptyView    = $('[data-search-empty]', so);
    const emptyQueryEl = $('[data-empty-query]', so);
    const resultsProducts    = $('[data-results-products]', so);
    const resultsCollections = $('[data-results-collections]', so);
    const resultsViewAll     = $('[data-results-view-all]', so);
    const resultsEyebrow     = $('[data-results-eyebrow]', so);
    const recentSection      = $('[data-search-recent]', so);
    const recentList         = $('[data-search-recent-list]', so);
    const recentClearBtn     = $('[data-search-recent-clear]', so);
    const form               = $('[data-search-form]', so);

    const RECENT_KEY = 'gslion:recent_searches';
    const RECENT_MAX = 6;
    const MIN_QUERY  = 2;
    const DEBOUNCE   = 220;

    /* ----- Recent searches (localStorage) ----- */
    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
      catch { return []; }
    }
    function setRecent(arr) {
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, RECENT_MAX))); }
      catch { /* private mode etc. */ }
    }
    function pushRecent(term) {
      term = (term || '').trim();
      if (term.length < MIN_QUERY) return;
      const list = getRecent().filter(t => t.toLowerCase() !== term.toLowerCase());
      list.unshift(term);
      setRecent(list);
    }
    function renderRecent() {
      const list = getRecent();
      if (!recentSection || !recentList) return;
      if (list.length === 0) { recentSection.hidden = true; return; }
      recentSection.hidden = false;
      recentList.innerHTML = list.map(t =>
        `<li><a href="/search?q=${encodeURIComponent(t)}" data-recent-term>${escapeHtml(t)}</a></li>`
      ).join('');
    }
    if (recentClearBtn) {
      recentClearBtn.addEventListener('click', () => { setRecent([]); renderRecent(); });
    }

    /* ----- Form submit (Enter key) ----- */
    form.addEventListener('submit', () => {
      pushRecent(input.value);
    });

    /* ----- Suggested chip click → also save as recent ----- */
    so.addEventListener('click', e => {
      const sug = e.target.closest('[data-search-suggest]');
      if (sug) pushRecent(sug.textContent);
    });

    /* ----- Clear button ----- */
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.hidden = true;
      showView('default');
      input.focus();
    });

    /* ----- Predictive search (debounced) ----- */
    let debounceTimer;
    let currentController;

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearBtn.hidden = q.length === 0;

      clearTimeout(debounceTimer);
      if (currentController) currentController.abort();

      if (q.length < MIN_QUERY) {
        showView('default');
        return;
      }

      debounceTimer = setTimeout(() => runSearch(q), DEBOUNCE);
    });

    async function runSearch(q) {
      showView('loading');
      currentController = new AbortController();
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
        const r = await fetch(url, { signal: currentController.signal, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('search_failed');
        const data = await r.json();
        renderResults(q, data.resources?.results || {});
      } catch (err) {
        if (err.name === 'AbortError') return;
        showView('empty');
        if (emptyQueryEl) emptyQueryEl.textContent = q;
      }
    }

    function renderResults(q, results) {
      const products    = results.products || [];
      const collections = results.collections || [];
      const total = products.length + collections.length;

      if (total === 0) {
        if (emptyQueryEl) emptyQueryEl.textContent = q;
        showView('empty');
        return;
      }

      if (resultsEyebrow) {
        resultsEyebrow.textContent = `Products${products.length ? ` · ${products.length}` : ''}`;
      }

      resultsProducts.innerHTML = products.slice(0, 6).map(p => {
        const img = p.featured_image?.url || p.image || '';
        const imgTag = img
          ? `<img src="${escapeAttr(img)}" alt="" width="56" height="56" loading="lazy">`
          : '';
        return `
          <li>
            <a href="${escapeAttr(p.url)}">
              <div class="so__list-img">${imgTag}</div>
              <div class="so__list-info">
                <span class="so__list-title">${escapeHtml(p.title)}</span>
                <span class="so__list-meta">${formatMoney(p.price)}</span>
              </div>
            </a>
          </li>`;
      }).join('') || '<li style="color:var(--c-mute);font-size:13px;padding:8px 0;">No products match.</li>';

      resultsCollections.innerHTML = collections.slice(0, 4).map(c => `
        <li>
          <a href="${escapeAttr(c.url)}">
            <div class="so__list-img"></div>
            <div class="so__list-info">
              <span class="so__list-title">${escapeHtml(c.title)}</span>
              <span class="so__list-meta">Collection</span>
            </div>
          </a>
        </li>`).join('') || '<li style="color:var(--c-mute);font-size:13px;padding:8px 0;">No collections match.</li>';

      if (resultsViewAll) {
        resultsViewAll.href = `/search?q=${encodeURIComponent(q)}`;
      }

      showView('results');
    }

    function showView(name) {
      defaultView.hidden = name !== 'default';
      resultsView.hidden = name !== 'results';
      loadingView.hidden = name !== 'loading';
      emptyView.hidden   = name !== 'empty';
    }

    function formatMoney(p) {
      if (p == null) return '';
      if (typeof p === 'string') return p;
      const dollars = p / 100;
      return dollars % 1 === 0 ? `$${dollars}` : `$${dollars.toFixed(2)}`;
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
    }
    function escapeAttr(s) { return escapeHtml(s); }

    /* ----- Keyboard navigation ----- */
    let focusables = [];
    let focusIdx = -1;

    function collectFocusables() {
      focusables = Array.from(so.querySelectorAll('.so__body a, .so__body button:not([hidden]):not([data-search-clear]):not([data-search-recent-clear])'))
        .filter(el => el.offsetParent !== null);
      focusIdx = -1;
    }

    input.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        collectFocusables();
        if (focusables.length) {
          focusIdx = 0;
          focusItem();
        }
      } else if (e.key === 'Escape') {
        if (input.value) {
          input.value = '';
          clearBtn.hidden = true;
          showView('default');
        } else {
          closeDrawer(so);
        }
      }
    });

    so.addEventListener('keydown', e => {
      if (document.activeElement === input) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        collectFocusables();
        focusIdx = focusables.indexOf(document.activeElement);
        focusIdx += (e.key === 'ArrowDown' ? 1 : -1);
        if (focusIdx >= focusables.length) { focusIdx = -1; input.focus(); return; }
        if (focusIdx < 0) { focusIdx = -1; input.focus(); return; }
        focusItem();
      }
    });

    function focusItem() {
      focusables.forEach((el, i) => el.classList.toggle('is-focused', i === focusIdx));
      const el = focusables[focusIdx];
      if (el) { el.focus({ preventScroll: false }); }
    }

    /* ----- On open: focus input, render recents ----- */
    new MutationObserver(() => {
      if (so.classList.contains('is-open')) {
        renderRecent();
        setTimeout(() => input.focus({ preventScroll: true }), 280);
      } else {
        // Reset on close
        input.value = '';
        clearBtn.hidden = true;
        showView('default');
      }
    }).observe(so, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Expose API ---------- */
  window.theme = { openDrawer, closeDrawer, refreshCart, cartDrawer };
})();
